module.exports = __webpack_public_path__ + "static/media/main2_zh_768-min.8718be01.png";